import useGlobalState from '../hooks/useGlobalState'
import DHLLogo from '../assets/dhl_logo.jpg'
import NYULogo from '../assets/nyu_logo.jpg'
import { cn } from '../utils/cn'

export default function HeaderLogos() {
    const downloadView = useGlobalState((state) => state.downloadView)
    return (
        <div
            className={cn(
                'w-full items-end md:w-auto',
                downloadView ? 'flex' : 'hidden'
            )}
        >
            <div className="flex items-center justify-end gap-2">
                <div className="my-4 flex w-full items-center md:my-0 md:w-auto">
                    <img
                        src={NYULogo}
                        alt="NYU Logo"
                        className="h-4 border-r-2 border-black pr-4"
                        rel="preload"
                    />
                    <img
                        src={DHLLogo}
                        alt="DHL Logo"
                        className="ml-4 h-5 md:w-auto"
                        rel="preload"
                    />
                </div>
            </div>
        </div>
    )
}
